import routeName from '../../../../routes/route-name';
import action from '../../../abstract/action';

export default action({
  main: () => false,
  label: 'Edytuj',
  handle: async ({ $router, item }) => await $router.push({ name: routeName.crmPartner.edit, params: { id: item.id } }),
});
